import type { JobDTO } from 'gw-edge-client/dist/types/dto/pc/top/edge/capabilities/onlinesales/dto';
import { atom } from 'recoil';
import { jobDtoSelector } from '../selectors/jobDtoSelector';

export const jobAtom = atom<JobDTO>({
    key: 'jobDTO',
    default: jobDtoSelector
});
